import { Sendum } from "../..";
import { Environment, getConfiguration } from "../../config";
import { ApiClient } from "./ApiClient";

export class AuthTokenClient extends ApiClient {
	private readonly authToken: string;

	constructor(authToken: string, env?: Environment) {
		const config = getConfiguration(env);

		super({
			baseApiUrl: config.headerAuthWidgetsApiUrl,
			apiVersion: config.headerAuthWidgetsApiVersion,
			basePath: config.baseApiPath,
		});

		this.authToken = authToken;
	}

	async appendHeaders(): Promise<HeadersInit> {
		return Promise.resolve({
			"auth-token": this.authToken,
		});
	}

}
